/** Trend direction, decoupled from `aos-helpers`' `Trend` enum. */
export type TrendDirection = 'up' | 'down' | 'flat'

/** Which direction counts as good — drives the arrow colour, not its shape. */
export type TrendPreference = 'up' | 'down'

export type TrendMeasureSize = 'regular' | 'small' | 'inline'

export type TrendMeasureLabelPosition = 'below' | 'inline'

export type TrendMeasureEmphasis = 'default' | 'muted'

/**
 * The `size` × `labelPosition` × `emphasis` cells Figma `Widget/Stat/TrendMeasure`
 * draws: `inline` always sets its label inline and is the only size with a muted
 * emphasis, `small` sets its label below or inline, `regular` only below.
 */
export type TrendMeasureVariant =
    | { size?: 'regular'; labelPosition?: 'below'; emphasis?: 'default' }
    | { size: 'small'; labelPosition?: TrendMeasureLabelPosition; emphasis?: 'default' }
    | { size: 'inline'; labelPosition?: 'inline'; emphasis?: TrendMeasureEmphasis }

export interface ResolvedTrendIcon {
    direction: 'up' | 'down'
    tone: 'success' | 'critical'
}

/**
 * A flat trend renders no arrow. Otherwise the arrow points the way the value
 * moved and is coloured by whether that movement is the preferred one.
 */
export const resolveTrendIcon = (
    direction: TrendDirection,
    preference: TrendPreference = 'up',
): ResolvedTrendIcon | null => {
    if (direction === 'flat') {
        return null
    }
    return { direction, tone: direction === preference ? 'success' : 'critical' }
}
